import { Indices } from './enums/indices';
import { getFullIndexName } from "../../Utils";

/**
 * Retrieves an object representing full index names for Algolia search, keyed by the original enum entries.
 * It reduces the Indices enum into an object with keys as the enum entries and values as the full index names.
 *
 * @returns {Object.<string, string>} An object with keys as index names and values as full Algolia index names.
 * @throws Will throw an error if the index name generation fails.
 */
export const getIndicesWithKeysAsObject = () => {
    try {
        return Object.values(Indices).reduce((acc, index) => {
            acc[index] = getFullIndexName(index);
            return acc;
        }, {});
    } catch (error) {
        console.error('Failed to get full index names:', error);
        throw error;
    }
};

export const roundRobinBestResultsFromAllIndices = async (
    searchClient,
    query,
    hitsPerPage
) => {
    const hitsToRender = [];
    const indices = getIndicesWithKeysAsObject();
    const queries = Object.keys(indices).map((key) => {
        return {
            indexName: indices[key],
            query: query || '',
            hitsPerPage,
            page: 0
        }
    });

    const results = await searchClient.multipleQueries(queries);
    let index = 0;
    let addedHits = true;
    while (hitsToRender.length < hitsPerPage && addedHits) {
        addedHits = false;
        for (const result of results.results) {
            if (index < result.hits.length) {
                hitsToRender.push(result.hits[index]);
                addedHits = true;
            }
            if (hitsToRender.length >= hitsPerPage) {
                break;
            }
        }
        index++;
    }

    return hitsToRender;
}